import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button, TextField, MenuItem, Chip, IconButton, CircularProgress, Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add"; import DeleteIcon from "@mui/icons-material/Delete"; import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
const LINK_TYPES = [{value:"related",label:"Related"},{value:"duplicate",label:"Duplicate"},{value:"same_property",label:"Same Property"}];
const LINK_COLOR = { related:"#2f63ad", duplicate:"#dc2626", same_property:"#7c3aed" };

const ViolationLinksTab = ({ violationId }) => {
  const [links, setLinks] = useState([]); const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false); const [linkedId, setLinkedId] = useState(""); const [linkType, setLinkType] = useState("related");
  const [error, setError] = useState(""); const navigate = useNavigate();
  const load = useCallback(async () => { setLoading(true); try { const r = await api.get(`/violations/${violationId}/links`); setLinks(r.data||[]); } catch {} finally { setLoading(false); } }, [violationId]);
  useEffect(() => { load(); }, [load]);
  const handleAdd = async () => {
    if (!linkedId) { setError("Enter a Violation ID."); return; } setError("");
    try { await api.post(`/violations/${violationId}/links`, { linked_violation_id: parseInt(linkedId,10), link_type: linkType }); setLinkedId(""); setShowAdd(false); load(); }
    catch (err) { setError(err.response?.data?.message || "Failed."); }
  };
  return (
    <Box>
      <Box sx={{ display:"flex", justifyContent:"space-between", alignItems:"center", mb:2 }}>
        <Typography variant="h6" sx={{ fontWeight:700, color:"#223142" }}>Linked Violations{links.length>0&&` (${links.length})`}</Typography>
        {!showAdd && <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={()=>setShowAdd(true)} sx={{ borderRadius:"10px", textTransform:"none", fontWeight:700, bgcolor:"#2f63ad", boxShadow:"none" }}>Link Violation</Button>}
      </Box>
      {showAdd && (
        <Box sx={{ p:2, mb:2, borderRadius:"12px", border:"1px solid rgba(47,99,173,0.12)", bgcolor:"rgba(47,99,173,0.02)" }}>
          {error && <Alert severity="error" sx={{ mb:1.5, borderRadius:2 }}>{error}</Alert>}
          <Box sx={{ display:"flex", gap:1.5, flexWrap:"wrap", alignItems:"flex-start" }}>
            <TextField size="small" label="Violation ID" type="number" value={linkedId} onChange={e=>setLinkedId(e.target.value)} sx={{ width:140, "& .MuiOutlinedInput-root":{ borderRadius:"10px" } }} />
            <TextField select size="small" label="Relationship" value={linkType} onChange={e=>setLinkType(e.target.value)} sx={{ width:160, "& .MuiOutlinedInput-root":{ borderRadius:"10px" } }}>
              {LINK_TYPES.map(lt=><MenuItem key={lt.value} value={lt.value}>{lt.label}</MenuItem>)}
            </TextField>
            <Button variant="contained" onClick={handleAdd} sx={{ borderRadius:"10px", textTransform:"none", fontWeight:700, bgcolor:"#2f63ad", boxShadow:"none" }}>Add</Button>
            <Button variant="outlined" onClick={()=>{setShowAdd(false);setError("");}} sx={{ borderRadius:"10px", textTransform:"none", fontWeight:600 }}>Cancel</Button>
          </Box>
        </Box>
      )}
      {loading ? <CircularProgress size={24} /> : links.length===0 ? (
        <Alert severity="info" sx={{ borderRadius:"10px" }}>No linked violations.</Alert>
      ) : (
        <Box sx={{ display:"flex", flexDirection:"column", gap:1 }}>
          {links.map(l=>(
            <Box key={l.id} sx={{ display:"flex", alignItems:"center", gap:1.5, p:1.5, borderRadius:"10px", border:"1px solid rgba(47,99,173,0.1)", bgcolor:"rgba(47,99,173,0.02)", cursor:"pointer" }} onClick={()=>navigate(`/home/violations/${l.linked_violation_id}`)}>
              <LinkIcon sx={{ color:"#9ca3af", fontSize:18 }} />
              <Chip size="small" label={LINK_TYPES.find(t=>t.value===l.link_type)?.label||l.link_type} sx={{ fontWeight:700, fontSize:11, borderRadius:"8px", bgcolor:`${LINK_COLOR[l.link_type]||"#2f63ad"}15`, color:LINK_COLOR[l.link_type]||"#2f63ad" }} />
              <Box sx={{ flex:1 }}>
                <Typography variant="body2" sx={{ fontWeight:700, color:"#2f63ad" }}>Violation #{l.linked_violation_id}</Typography>
                <Typography variant="caption" sx={{ color:"#6b778c" }}>{l.type_name} · {l.status}</Typography>
              </Box>
              <IconButton size="small" color="error" onClick={async e=>{e.stopPropagation();await api.delete(`/violation-links/${l.id}`);load();}}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};
export default ViolationLinksTab;
